import { OccasionPageLayout } from '@/components/seo/OccasionPageLayout';
import { getOccasion } from '@/data/occasions';
export default function RetirementTribute() {
  const o = getOccasion('retirement-tribute')!;
  return <OccasionPageLayout occasion={o} />;
}
